import * as React from 'react'
import { Badge } from '@lightspeed/design-system-react'
import { VendImage } from '@vend/react-utilities'

interface Props {
  header?: React.ReactNode
  description?: React.ReactNode
}

export const ServiceItemBadge: React.FC<Props> = ({ header, description }) => (
  <Badge
    size="small"
    avatar={
      <VendImage
        relativeImagePath="service-orders/service-item-light-v2.svg"
        relativeDarkImagePath="service-orders/service-item-dark-v2.svg"
      />
    }
    header={header}
    description={description}
  />
)
